import gql from 'graphql-tag';

const cancelledPurchasesQuery = gql`
  query cancelledPurchasesQuery($vin: String, $size: Int, $offset: Int, $dealerNumber: String) {
    cancelledPurchases(vin: $vin, offset: $offset, size: $size, dealerNumber: $dealerNumber) {
      id
      buyerEmail
      cancellingUserName
      auctionAccessNo
      dealerNo
      vin
      universalNo
      guaranteeDaysSelected
      guaranteeMilesSelected
      guaranteeIfBid
      guaranteeSellerPaid
      automaticPurchase
      vehiclePurchasePrice
      guaranteePrice
      inspectionPrice
      cancellationDate
      cancellationReason
      guaranteeOffer {
        guaranteeStatus
        product {
          name
        }
      }
    }
  }
`;

export default cancelledPurchasesQuery;
